import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import PanelsRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Panels/Renderer/PanelsRenderer'

const PanelsForm = lazyLoad(() => import('./Form/PanelsForm'))

const panelsPlugin = settings =>
    createPlugin({
        Renderer: PanelsRenderer,
        Controls: PanelsForm,
        ...settings,
    })

const panels = panelsPlugin()
export default panels

export { panelsPlugin, PanelsRenderer }
